import Component from "../../lib/component";
import { JSVoidString } from "../../helpers/js_void";
import iconDownObtuseChevron from "./assets/icon__down_obtuse_chevron.svg";
import {htmlEncode, toTitleCase} from "../../helpers/string";

export const PaneSlideButtonConfig = {
  componentTypeKey: "PaneSlideButton",
  baseHtmlClass: "pane_slides__btn",
  selector: ".pane_slides__btn",
  datasetConfigKey: "pane_slide_button__config",

  prevKindCode: "prev",
  nextKindCode: "next",

  scrollHintHtmlClass: "pane_slides__btn__scroll_hint",
  scrollHintLabel: "Scroll",
};

export class PaneSlideButton extends Component {
  static get config() {
    return PaneSlideButtonConfig;
  }

  static createElement(kind) {
    const element = document.createElement("div");
    element.classList.add(PaneSlideButton.config.baseHtmlClass);
    element.dataset[PaneSlideButton.config.datasetConfigKey] = htmlEncode(
      JSON.stringify({ kind: kind }),
    );
    const linkElement = document.createElement("a");
    linkElement.setAttribute("href", JSVoidString);
    linkElement.setAttribute("title", toTitleCase(kind));
    const svgElement = new DOMParser().parseFromString(
      iconDownObtuseChevron,
      "image/svg+xml",
    ).documentElement;
    svgElement.style.cssText = "display:block;height:100%;width:100%;";
    linkElement.appendChild(svgElement);
    element.appendChild(linkElement);
    return element;
  }

  constructor(id_or_element, paneSlide) {
    super({
      element: id_or_element,
      config: PaneSlideButtonConfig,
    });

    this.paneSlide = paneSlide;

    this.setDatasetConfig(PaneSlideButton.config.datasetConfigKey);
    this.kind = this.getDatasetConfigValue("kind");
    this.hint = this.getDatasetConfigValue("hint");

    if (this.hint) {
        this.element.title = this.hint
    }

    this.linkElement = this.element.querySelector("a");

    this.linkElement.addEventListener("click", this.handleClick.bind(this));

    // The first slide's next arrow carries the "Scroll" nudge label; whether it is actually
    // shown is the parent carousel's call (the `pane_slides--scroll_hint` class state).
    if (this.isNextKind() && this.paneSlide.getSlidePosition() === 0) {
      this.scrollHintElement = createScrollHintElement(this.linkElement);
    }
  }

  handleClick(event) {
    const target = this.getTargetPaneSlide();
    if (target) {
      event.preventDefault();
      this.paneSlide.slideTo(target);
    }
  }

  render() {
    if (this.linkElement) {
      const target = this.getTargetPaneSlide();
      this.linkElement.href = !!target ? `#${target.id}` : JSVoidString;
    }
    this.conditionallySetHtmlClassState(this.isPrevKind(), "prev");
    this.conditionallySetHtmlClassState(this.isNextKind(), "next");
    this.conditionallySetHtmlClassState(
      !this.hasTargetPaneSlide(),
      "no_target",
    );
  }

  hasTargetPaneSlide() {
    return this.getTargetPaneSlide() !== null;
  }

  getTargetPaneSlide() {
    if (this.isPrevKind()) return this.paneSlide.getPrevSlide();
    if (this.isNextKind()) return this.paneSlide.getNextSlide();
    return null;
  }

  isPrevKind() {
    return this.kind === PaneSlideButton.config.prevKindCode;
  }

  isNextKind() {
    return this.kind === PaneSlideButton.config.nextKindCode;
  }
}

function createScrollHintElement(linkElement) {
  const element = document.createElement("span");
  element.classList.add(PaneSlideButton.config.scrollHintHtmlClass);
  element.setAttribute("aria-hidden", "true"); // Decorative — the link's title already says it.
  element.textContent = PaneSlideButton.config.scrollHintLabel;
  linkElement.appendChild(element);
  return element;
}
